import { Edit } from 'react-admin';
import { CompanyForm } from './index';
import { EditToolbar } from "@components/EditToolbar";

export const CompanyEdit = () => (
  <Edit mutationMode="pessimistic">
    <CompanyForm toolbar={<EditToolbar showDeleteButton={false} />} />
  </Edit>
);
